import React, { useEffect, useRef, useState } from "react";
import { useAppState } from "../contexts/AppContext";
import { Link } from "react-router-dom";
import Pagination from "../components/Pagination";
import { getSeries } from "../helpers/Series";


export default function Series() {
    const { appState } = useAppState();
    const [series, setSeries] = useState<Array<any>>([])
    const [search, setSearch] = useState<string | null>(null)
    const [page, setPage] = useState<number>(1)
    const [meta, setMeta] = useState<any>({
        page: 1,
        totalPages: 1,
    });
    const abortController = useRef<AbortController>();


    useEffect(() => {
        if (abortController.current) {
            abortController.current.abort()
        }
        abortController.current = new AbortController();
        getSeries(10, page, search, { signal: abortController.current.signal }).then((result) => {
            setSeries(result.data)
            setMeta({
                page: result.current_page,
                totalPages: result.last_page,
            })
        })
    }, [page, search])

    useEffect(() => {
        setPage(1);
    }, [search])

    return (
        <>
            <div className="flex justify-between items-center">
                <div>
                    <h1 className="text-xl">Series</h1>
                    <input onChange={(event) => { setSearch(event.target.value) }}></input>
                </div>
                <Link to="/series/create" className="px-4 py-2 bg-blue-500 text-white rounded">Create Series</Link>
            </div>
            <div className="mt-3 p-3 rounded bg-white">
                <table className="w-full">
                    <thead className="text-left">
                        <tr className="border-b-1">
                            <th className="p-2">Id</th>
                            <th className="p-2">Name</th>
                            <th className="p-2 text-right">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {series.map((seriesItem: any) => {
                            return (
                                <tr className="border-b-1 border-gray-300">
                                    <td className="p-2">
                                        <Link to={`/categories/${seriesItem.id}`}>{seriesItem.id}</Link>
                                    </td>
                                    <td className="p-2">{seriesItem.name}</td>
                                    <td className="p-2 ">
                                        <ul className="flex justify-end gap-x-2">
                                            <li>
                                                <Link to={`/series/${seriesItem.id}`}>View</Link>
                                            </li>
                                        </ul>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
            {series && series.length > 0 ? (
                <div className="w-full mt-5">
                    <Pagination page={meta.page} totalPages={meta.totalPages} onCallback={setPage} />
                </div>
            ) : null}

        </>
    );
}
